import { h, field, screen, errorText } from '../components/ui.js';
import { auth } from '../services/authService.js';

function form(onSubmit, submitLabel, ...fields) {
  const msg = h('p', { class: 'pc-msg', role: 'status' });
  const btn = h('button', { class: 'btn btn-primary pc-wide', type: 'submit' }, submitLabel);
  const el = h('form', { onsubmit: async e => {
    e.preventDefault(); btn.disabled = true; msg.textContent = ''; msg.className = 'pc-msg';
    try { const ok = await onSubmit(); if (ok) { msg.textContent = ok; msg.classList.add('ok'); } }
    catch (err) { msg.textContent = errorText(err); msg.classList.add('err'); }
    finally { btn.disabled = false; }
  } }, ...fields, msg, btn);
  return el;
}
const input = (type, autocomplete, extra = {}) => h('input', { type, required: true, autocomplete, ...extra });
const link = (label, fn) => h('button', { class: 'pc-link', type: 'button', onclick: fn }, label);

export function showLogin() {
  const email = input('email', 'username'), pass = input('password', 'current-password');
  screen('Entrar', 'Sistema de gestão da Dream Studio 3D.',
    form(async () => { await auth.signIn(email.value.trim(), pass.value); }, 'Entrar', field('E-mail', email), field('Senha', pass)),
    h('div', { class: 'pc-links' }, link('Esqueci minha senha', showForgot), link('Recebi um convite', showSignUp)));
  email.focus();
}
export function showForgot() {
  const email = input('email', 'username');
  screen('Recuperar senha', 'Enviaremos um link para redefinir sua senha.',
    form(async () => { await auth.forgot(email.value.trim()); return 'Se o e-mail estiver cadastrado, o link chegará em instantes.'; }, 'Enviar link', field('E-mail', email)),
    h('div', { class: 'pc-links' }, link('Voltar', showLogin)));
}
export function showSignUp() {
  const name = input('text', 'name'), email = input('email', 'username'), pass = input('password', 'new-password', { minlength: 10 });
  screen('Criar conta', 'Use o mesmo e-mail que recebeu o convite.',
    form(async () => { await auth.signUp(email.value.trim(), pass.value, name.value.trim()); return 'Conta criada. Confirme pelo link enviado ao seu e-mail.'; }, 'Criar conta',
      field('Nome', name), field('E-mail', email), field('Senha (mínimo 10 caracteres)', pass)),
    h('div', { class: 'pc-links' }, link('Já tenho conta', showLogin)));
}
export function showNewPassword(done) {
  const pass = input('password', 'new-password', { minlength: 10 });
  screen('Definir nova senha', null,
    form(async () => { await auth.updatePassword(pass.value); done(); }, 'Salvar senha', field('Nova senha (mínimo 10 caracteres)', pass)));
}
